<template>
  <div class="container fluid">
    <v-card>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
      >
        <v-toolbar-title class="justify-center">
          <h1 class="display-1 headline text--accent-1">
            PAT Reporting
          </h1>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
        height="72px"
      >
        <v-tabs
          v-model="tab"
          slider-color="amber"
          grow
          color="primary"
          centered
          icons-and-text
        >
          <v-tab
            v-for="(item, id) in tabs"
            :key="id"
            :href="`#${id}`"
          >
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(item, id) in tabs"
          :key="id"
          :value="`${id}`"
        >
          <v-card flat>
            <component :is="item.component" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {
  EmailsLoan,
  EmailsBaader,
  EmailsYield,
  JEA2020,
  JEA2021,
  JEA2022,
  JEA2023,
  JEA2024,
  JEA2025,
  FailedJobs,
} from '@/components/payoutsAndTaxes';

export default {
  name: 'ReportingView',
  components: {
  },
  data() {
    return {
      tab: null,
      tabs: {
        PayoutEmails: {
          title: 'Financing Emails',
          icon: 'email',
          component: EmailsLoan,
        },
        YieldEmails: {
          title: 'Yield Emails',
          icon: 'email',
          component: EmailsYield,
        },
        BaaderEmails: {
          title: 'Baader Emails',
          icon: 'email',
          component: EmailsBaader,
        },
        JEA2020: {
          title: 'JEA 2020',
          icon: 'functions',
          component: JEA2020,
        },
        JEA2021: {
          title: 'JEA 2021',
          icon: 'functions',
          component: JEA2021,
        },
        JEA2022: {
          title: 'JEA 2022',
          icon: 'functions',
          component: JEA2022,
        },
        JEA2023: {
          title: 'JEA 2023',
          icon: 'functions',
          component: JEA2023,
        },
        JEA2024: {
          title: 'JEA 2024',
          icon: 'functions',
          component: JEA2024,
        },
        JEA2025: {
          title: 'JEA 2025',
          icon: 'functions',
          component: JEA2025,
        },
        FailedJobs: {
          title: 'Failed Jobs',
          icon: 'report_problem',
          component: FailedJobs,
        },
      },
    };
  },
  computed: {
    currentTabName() {
      if (this.tab === null) {
        return '';
      }

      return `${this.tabs[this.tab].title}`;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/reporting/ReportingView.vue